import { AclSubject, AclSubjectType } from '@y42/acl/models';
import { UserUIModel } from '@y42/user/models';

export interface AclUserSubject extends AclSubject {
  subject_type: AclSubjectType.User;
}

export const createAclUserSubject = (userId: UserUIModel['id']): AclUserSubject => ({
  subject_type: AclSubjectType.User,
  subject_id: `${userId}`,
});
